export enum ActivitiesTypes {
  FETCH_ACTIVITIES_REQUEST = '@activities/FETCH_ACTIVITIES_REQUEST',
  FETCH_ACTIVITIES_SUCCESS = '@activities/FETCH_ACTIVITIES_SUCCESS',
  FETCH_ACTIVITIES_FAILURE = '@activities/FETCH_ACTIVITIES_FAILURE',
}

export interface ActivityData {
  id: number;
  codigo: string;
  nome: string;
}

export interface RequestData {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RequestState {
  fetch_activities: RequestData;
}

export interface ActivitiesData {
  [key: string]: Array<ActivityData>;
}

export interface ActivitiesState {
  readonly activities: ActivitiesData;
  readonly request: RequestState;
}
